import React, { useState } from 'react';
import {
  Divider,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from '@mui/material';
import BuildingStubCreator from './BuildingStubCreator';
import TagUploadForm from './TagUploadForm';
import './UploadResultView';

import './Upload.css';

const getUploadView = (uploadType) => {
  switch (uploadType) {
    case 'tagPointType':
    case 'tagEquipmentType':
    case 'tagCreate':
      return <TagUploadForm key={uploadType} variant={uploadType} />;
    case 'newBuildingStub':
    default:
      return <BuildingStubCreator />;
  }
};

const UploadSelection = () => {
  const [uploadType, setType] = useState('newBuildingStub');
  return (
    <div className="Upload-center">
      <FormControl component="fieldset">
        <FormLabel component="legend">Select upload type:</FormLabel>
        <RadioGroup
          name="uploadType"
          color="secondary"
          value={uploadType}
          onChange={(e) => setType(e.target.value)}
        >
          <FormControlLabel
            value="newBuildingStub"
            control={<Radio />}
            label="New empty building"
          />
          <Divider />
          <FormControlLabel value="tagCreate" control={<Radio />} label="Create or update tags" />
          <FormControlLabel
            value="tagPointType"
            control={<Radio />}
            label="Associate tags with point types"
          />
          <FormControlLabel
            value="tagEquipmentType"
            control={<Radio />}
            label="Associate tags with equipment types"
          />
        </RadioGroup>
      </FormControl>
      <hr />
      {getUploadView(uploadType)}
    </div>
  );
};

export default UploadSelection;
